import { Button, Divider } from "antd";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import { selectLicenseList } from "../Body/api/redux";
import L from "leaflet";
import {
  FeatureGroup,
  MapContainer,
  Marker,
  Pane,
  GeoJSON,
  TileLayer,
} from "react-leaflet";

export default (props) => {
  const state = useSelector(selectLicenseList);
  const [isOpened, setIsOpened] = useState(false);
  const { data } = props;

  return (
    <div className="col-12 potenital-card text-right d-flex flex-wrap my-1">
      {" "}
      {data.title && (
        <div className="col-12 my-2">
          <span style={{ color: "#6c6c6c", fontSize: "13.4px" }}>
            پتانسیل سرمایه گذاری
          </span>
          <br />
          <h6 className="mt-1 lh-30">{data.title}</h6>
        </div>
      )}
      {/* <Divider className="col-12 my-0" /> */}
      {data.Township && (
        <div className="col-6 my-2">
          <span style={{ color: "#6c6c6c", fontSize: "13.4px" }}>شهرستان</span>
          <br />
          <h6 className="mt-1 lh-30">{data.Township.title}</h6>
        </div>
      )}
      {data.Part && (
        <div className="col-6 my-2">
          <span style={{ color: "#6c6c6c", fontSize: "13.4px" }}>بخش</span>
          <br />
          <h6 className="mt-1 lh-30">{data.Part.title}</h6>
        </div>
      )}
      {data.City && (
        <div className="col-6 my-2">
          <span style={{ color: "#6c6c6c", fontSize: "13.4px" }}>شهر</span>
          <br />
          <h6 className="mt-1 lh-30">{data.City.title}</h6>
        </div>
      )}
      <Divider className="col-12 my-2" />
      {data.Sector && (
        <div className="col-6 my-2">
          <span style={{ color: "#6c6c6c", fontSize: "13.4px" }}>
            بخش سرمایه گذاری
          </span>
          <br />
          <h6 className="mt-1 lh-30">{data.Sector.title}</h6>
        </div>
      )}
      {data.SubSector && (
        <div className="col-6 my-2">
          <span style={{ color: "#6c6c6c", fontSize: "13.4px" }}>
            زیربخش سرمایه گذاری
          </span>
          <br />
          <h6 className="mt-1 lh-30">{data.SubSector.title}</h6>
        </div>
      )}
      <Divider className="col-12 my-2" />
      {data.recommender && (
        <div className="col-6 my-2">
          <span style={{ color: "#6c6c6c", fontSize: "13.4px" }}>
            پیشنهاد دهنده
          </span>
          <br />
          <h6 className="mt-1 lh-30">{data.recommender}</h6>
        </div>
      )}
      {isOpened && (
        <>
          {state.province && (
            <>
              <div className="col-12" style={{ height: "8rem" }}>
                <MapContainer
                  maxZoom={15}
                  bounds={
                    state.province.spanData.type === "MultiPolygon"
                      ? state.province?.spanData?.coordinates[0][0].map(
                          (el) => {
                            return [el[1], el[0]];
                          }
                        )
                      : state.province?.spanData?.coordinates[0].map((el) => {
                          return [el[1], el[0]];
                        })
                  }
                >
                  <TileLayer
                    attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                    key={1}
                  />
                  <FeatureGroup>
                    <Pane style={{ zIndex: 5999999999 }}>
                      {data.spanData && (
                        <GeoJSON
                          data={data?.spanData}
                          style={{
                            color: "red",
                            fillOpacity: "60%",
                            weight: 4,
                          }}
                        />
                      )}
                      {data?.point?.coordinates && (
                        <Marker position={data?.point.coordinates}></Marker>
                      )}
                    </Pane>

                    {state.province && (
                      <GeoJSON data={state.province?.spanData} />
                    )}
                  </FeatureGroup>
                </MapContainer>
              </div>
              <div className="col-12 my-3 d-flex justify-content-end">
                <div className="col-6">
                  <Button
                    className="w-100"
                    style={{
                      height: "3rem",
                      borderRadius: "6px",
                    }}
                  >
                    <a href={data.link} target="_blank">
                      اعلام أمادگی
                    </a>
                  </Button>
                </div>
                <div className="col-6">
                  <Button
                    className="w-100"
                    style={{
                      height: "3rem",
                      borderRadius: "6px",
                    }}
                  >
                    <a href={data.fileLink} target="_blank">
                      توضیحات بیشتر
                    </a>
                  </Button>
                </div>
              </div>
            </>
          )}
        </>
      )}
      <div
        className="col-12 text-center d-flex align-items-center justify-content-center"
        style={{ gap: "5px", cursor: "pointer" }}
        onClick={() => {
          setIsOpened(!isOpened);
        }}
      >
        <h6 className="my-auto">{isOpened ? "بستن" : "جزییات بیشتر"}</h6>
        <i className={isOpened ? "fa fa-arrow-up" : "fa fa-arrow-down"}></i>
      </div>
    </div>
  );
};
